"use client";

import { Flowbite } from "flowbite-react";
import { PropsWithChildren } from "react";
import logrockTheme from "@/logrock.theme";
export default function FlowbiteThemeProvider({
  children
}: PropsWithChildren) {
  return <Flowbite theme={{
    mode: "light",
    theme: logrockTheme
  }} data-sentry-element="Flowbite" data-sentry-component="FlowbiteThemeProvider" data-sentry-source-file="FlowbiteThemeProvider.tsx">
      {children}
    </Flowbite>;
}